import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  breadCrumbLink: {
    textDecoration: 'none',
    // color: theme.palette.grey[500],
    color: '#FFF',
    opacity: 0.5,
    textTransform: 'none',
    marginTop: '1px',
    fontSize: '0.85rem',
  },
  breadcrumb: {
    size: '200px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
  },
  activeBreadcrumbLink: {
    textDecoration: 'none',
    // color: 'rgb(2, 123, 253) !important',
    color: '#FFF',
    textTransform: 'none',
    fontSize: '0.85rem',
    '& .MuiBox-root': {
      fontWeight: 'normal',
    },
  },
  backNaviIcon: {
    textDecoration: 'none',
    // color: 'rgb(2, 123, 253) !important',
    color: '#FFF',
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '0.85rem',
    // margin: '5px',
  },
  buttonStyle: {
    margin: '0px',
  },
  backNaviText: {
    textTransform: 'none',
    fontSize: '0.85rem',
    // fontWeight: 'bold',
  },
  root: {
    '& > * + *': {
      marginTop: theme.spacing(8),
    },
    '& .MuiBreadcrumbs-separator': {
      fontSize: '2rem',
      fontWeight: 'normal',
      // color: 'rgb(2, 123, 253) !important',
      color: '#FFF',
      opacity: 0.5,
      margin: '4px',
      paddingBottom: '15px',
      height: '40px',
    },
  },
}));
